import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, Zoom } from "react-toastify";

import Dashboard from "./pages/Dashboard";
import LoginScreen from "./pages/auth/Login";
import PasswordReset from "./pages/auth/PasswordReset";
import Slider from "./pages/Slider";
import About from "./pages/About";
import ServicesCategory from "./pages/services/Category";
import Services from "./pages/services/Services";
import AboutUsCategory from "./pages/about_us/AboutusCategory";
import AboutUsContent from "./pages/about_us/AboutUsContent";
import PhotoGallery from "./pages/PhotoGallery";
import VideoGallery from "./pages/VideoGallery";
import ElectronicMedia from "./pages/ElectronicMedia";
import PrintMedia from "./pages/PrintMedia";
import Blog from "./pages/Blog";
import ResourceCategory from "./pages/resource/ResourceCategory";
import ResourceContent from "./pages/resource/ResourceContent";
import Appointment from "./pages/Appointment";
import WebsiteSetting from "./pages/WebsiteSetting";
import FooterLink from "./pages/FooterLink";
import NotFoundPage from "./components/NotFoundPage";
import Biography from "./pages/BIography";
import LifeStruggle from "./pages/LifeStruggle";
import PhotoGalleryCategory from "./pages/PhotoGalleryCategory";
import AboutMe from "./pages/AboutMe";
import Contact from "./pages/Contact";
import CitizenRequestList from "./pages/CitizenRequestList";
import UnionList from "./pages/UnionList";
import User from "./pages/User";
import Unauthorized from "./pages/Unauthorized";

import ProtectedRoute from "./routes/ProtectedRoute";
import GuestRoute from "./routes/GuestRoute";
import PermissionRoute from "./routes/PermissionRoute";
import AppInitializer from "./components/AppInitializer";
import DevelopmentWorkCategory from "./pages/developmentwork/DevelopmentCategory";
import DevelopmentWorkContent from "./pages/developmentwork/DevelopmentContent";

function App() {
    return (
        <>
            <Router>
                <AppInitializer>
                    <Routes>
                        <Route element={<GuestRoute />}>
                            <Route path="/login" element={<LoginScreen />} />
                            <Route path="/reset-password/:token" element={<PasswordReset />} />
                        </Route>

                        <Route element={<ProtectedRoute />}>
                            <Route
                                path="/"
                                element={
                                    <PermissionRoute permission="dashboard.view">
                                        <Dashboard />
                                    </PermissionRoute>
                                }
                            />

                            <Route
                                path="/slider"
                                element={
                                    <PermissionRoute permission="slider.view">
                                        <Slider />
                                    </PermissionRoute>
                                }
                            />

                            <Route
                                path="/about"
                                element={
                                    <PermissionRoute permission="about.view">
                                        <About />
                                    </PermissionRoute>
                                }
                            />

                            <Route
                                path="/biography"
                                element={
                                    <PermissionRoute permission="biography.view">
                                        <Biography />
                                    </PermissionRoute>
                                }
                            />

                            <Route
                                path="/life-struggle"
                                element={
                                    <PermissionRoute
                                        permissions={["biography.view", "life_struggle.view"]}
                                    >
                                        <LifeStruggle />
                                    </PermissionRoute>
                                }
                            />

                            <Route
                                path="/about-me"
                                element={
                                    <PermissionRoute permission="about_me.view">
                                        <AboutMe />
                                    </PermissionRoute>
                                }
                            />

                            <Route
                                path="/services-category"
                                element={
                                    <PermissionRoute permission="services_category.view">
                                        <ServicesCategory />
                                    </PermissionRoute>
                                }
                            />

                            <Route
                                path="/services"
                                element={
                                    <PermissionRoute permission="services.view">
                                        <Services />
                                    </PermissionRoute>
                                }
                            />

                            <Route
                                path="/about-us-category"
                                element={
                                    <PermissionRoute permission="about_us_category.view">
                                        <AboutUsCategory />
                                    </PermissionRoute>
                                }
                            />

                            <Route
                                path="/about-us-content"
                                element={
                                    <PermissionRoute permission="about_us_content.view">
                                        <AboutUsContent />
                                    </PermissionRoute>
                                }
                            />


                            <Route
                                path="/development-work-category"
                                element={
                                    <PermissionRoute permission="about_us_category.view">
                                        <DevelopmentWorkCategory/>
                                    </PermissionRoute>
                                }
                            />

                            <Route
                                path="/development-work-content"
                                element={
                                    <PermissionRoute permission="about_us_content.view">
                                        <DevelopmentWorkContent/>
                                    </PermissionRoute>
                                }
                            />


                            <Route
                                path="/photo-gallery"
                                element={
                                    <PermissionRoute permission="photo_gallery.view">
                                        <PhotoGallery />
                                    </PermissionRoute>
                                }
                            />

                            <Route
                                path="/photo-gallery-category"
                                element={
                                    <PermissionRoute permission="photo_gallery_category.view">
                                        <PhotoGalleryCategory />
                                    </PermissionRoute>
                                }
                            />

                            <Route
                                path="/video-gallery"
                                element={
                                    <PermissionRoute permission="video_gallery.view">
                                        <VideoGallery />
                                    </PermissionRoute>
                                }
                            />

                            <Route
                                path="/print-media"
                                element={
                                    <PermissionRoute permission="print_media.view">
                                        <PrintMedia />
                                    </PermissionRoute>
                                }
                            />

                            <Route
                                path="/blog"
                                element={
                                    <PermissionRoute permission="electronic_media.view">
                                        <Blog />
                                    </PermissionRoute>
                                }
                            />

                            <Route
                                path="/electronic-media"
                                element={
                                    <PermissionRoute permission="electronic_media.view">
                                        <ElectronicMedia />
                                    </PermissionRoute>
                                }
                            />

                            <Route
                                path="/resource-category"
                                element={
                                    <PermissionRoute permission="resource_category.view">
                                        <ResourceCategory />
                                    </PermissionRoute>
                                }
                            />

                            <Route
                                path="/resource-content"
                                element={
                                    <PermissionRoute permission="resource_content.view">
                                        <ResourceContent />
                                    </PermissionRoute>
                                }
                            />

                            <Route
                                path="/appointment"
                                element={
                                    <PermissionRoute permission="appointment.view">
                                        <Appointment />
                                    </PermissionRoute>
                                }
                            />

                            <Route
                                path="/contact"
                                element={
                                    <PermissionRoute permission="contact.view">
                                        <Contact />
                                    </PermissionRoute>
                                }
                            />

                            <Route
                                path="/website-setting"
                                element={
                                    <PermissionRoute permission="website_setting.view">
                                        <WebsiteSetting />
                                    </PermissionRoute>
                                }
                            />

                            <Route
                                path="/footer-link"
                                element={
                                    <PermissionRoute permission="footer_link.view">
                                        <FooterLink />
                                    </PermissionRoute>
                                }
                            />

                            <Route
                                path="/citizen-request"
                                element={
                                    <PermissionRoute permission="citizen_request.view">
                                        <CitizenRequestList />
                                    </PermissionRoute>
                                }
                            />

                            <Route
                                path="/unions"
                                element={
                                    <PermissionRoute permission="union.view">
                                        <UnionList />
                                    </PermissionRoute>
                                }
                            />

                            <Route
                                path="/users"
                                element={
                                    <PermissionRoute permission="user.view">
                                        <User />
                                    </PermissionRoute>
                                }
                            />

                            <Route path="/unauthorized" element={<Unauthorized />} />
                        </Route>

                        <Route path="*" element={<NotFoundPage />} />
                    </Routes>
                </AppInitializer>
            </Router>

            <ToastContainer
                position="top-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
                transition={Zoom}
                style={{
                    width: "300px",
                    fontSize: "14px",
                }}
            />
        </>
    );
}

export default App;
